
function base64UrlEncode(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (const b of bytes) binary += String.fromCharCode(b);
  const base64 = btoa(binary);
  const urlSafe = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  return urlSafe;
}


export function randomString(length = 64): string {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const rnd = crypto.getRandomValues(new Uint8Array(length));
  return Array.from(rnd, (n) => charset[n % charset.length]).join('');
}


async function sha256(input: string): Promise<ArrayBuffer> {
  const data = new TextEncoder().encode(input);
  const hasSubtle = !!(typeof crypto !== 'undefined' && (crypto as any).subtle && typeof (crypto as any).subtle.digest === 'function');
  
 if (!hasSubtle) {
    // Error técnico para logs; el componente debe mostrar mensaje genérico al usuario.
    throw new Error('WEB_CRYPTO_UNAVAILABLE: Requiere contexto seguro (HTTPS o localhost) para PKCE S256.');
  }
  return (crypto as any).subtle.digest('SHA-256', data);

}


export function generateCodeVerifier(length = 64): string {
  if (length < 43 || length > 128) {
    throw new Error('code_verifier length must be between 43 and 128 characters.');
  }
  const verifier = randomString(length);
  return verifier;
}


export async function generateCodeChallenge(verifier: string): Promise<string> {
  const hash = await sha256(verifier);
  const challenge = base64UrlEncode(hash);
  return challenge;
}


export function buildQuery(params: Record<string, string | number | undefined | null>): string {
  const entries = Object.entries(params).filter(([_, v]) => v !== undefined && v !== null);
  const qs = entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&');  
  return qs;
}
